import { render, staticRenderFns } from "./imageList.vue?vue&type=template&id=dd8f6cd0&scoped=true"
import script from "./imageList.vue?vue&type=script&lang=js"
export * from "./imageList.vue?vue&type=script&lang=js"
import style0 from "./imageList.vue?vue&type=style&index=0&id=dd8f6cd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8f6cd0",
  null
  
)

export default component.exports